/**
 * 画像識別子から表示用のURLを生成します。
 * @param {string | null | undefined} identifier - 画像識別子 (ファイル名 or 完全なURL)
 * @returns {string | null} 表示に使用するURL、または識別子が無効な場合は null
 */
export const getImageUrl = (identifier) => {
    if (!identifier) {
        return null;
    }

    // ★ 修正: /local_files/ で始まる場合もそのまま返すように追加 ★
    if (identifier.startsWith('http') || identifier.startsWith('/local_files/')) {
        return identifier;
    } else {
        // それ以外の場合（ファイル名のみなど）は /local_files/ を付与
        const localUrl = `/local_files/${identifier}`;
        return localUrl;
    }
};
